<template>
  <template v-if="mode === 'view'">

  <div class="px-lg-3">
    <v-sheet class="d-flex flex-wrap my-lg-2 px-1">
      <v-sheet class="my-1 mr-4">
        <span class="text-h5">LID</span><span class="text-h5 font-weight-bold">{{v.lid}}</span>
      </v-sheet>
      <div class="d-none d-sm-none d-md-flex">
        <v-sheet class="my-1 mr-4">
          <span class="text-h5">{{ v.current_storage.name }} <v-tooltip activator="parent" location="bottom">Current storage</v-tooltip></span>
        </v-sheet>
      </div>
      <v-sheet class="my-1 mr-4 flex-nowrap">
        <span class="text-h5"> {{ v.main_storage.name }}<v-tooltip activator="parent" location="bottom">Main storage</v-tooltip></span> 
        <span class="text-h5 font-weight-bold"> {{ v.localcollnumber }} <v-tooltip activator="parent" location="bottom">Local collection number</v-tooltip></span>
      </v-sheet>

    </v-sheet>
    <!--px-2 - make padding -->
            <!--три блока - бюрократия, география, таксономия--> 


    <div class="d-none d-sm-none d-md-flex my-1 my-lg-2 px-1">
        <span class="text-h3 font-weight-black text-truncate" style="max-width: 1500px;">{{ v.store_species }} <v-tooltip activator="parent" location="end">Store species</v-tooltip></span>
    </div>
    <div class=" px-1 text-h5 text-truncate"> {{ v.species.name }} </div><!--mobile-->
    <div class="ml-1 mr-2"><image-widget v-if="v.pictures" v-bind="{mode:'view',column:meta}" v-model="v.pictures" /></div>

    <v-divider class="ma-2"></v-divider>

  </div>

  <div class="d-none d-sm-none d-md-flex">
    <v-btn
      v-if="v.coordinates"
      variant="text"
      color=""
      v-copy="v.coordinates"
      @click="clicktooltipMessage"
    >
      <span class="text-h5">
        <point-widget v-bind="{mode:'view',column:column}" v-model="v.coordinates" /> 
      </span>
      <v-tooltip
        activator="parent"
        location="bottom"
      >
        Coordinates. {{clicktooltip}}
      </v-tooltip>
    </v-btn>
    <v-btn
      v-if="v.legdate"
      variant="text"
      color="">
        <span class="text-h5"><date-widget v-bind="{mode:'view',column:column}" v-model="v.legdate" /></span>
        <v-tooltip
          activator="parent"
          location="bottom"
        >
          Leg. Date
        </v-tooltip>
    </v-btn>
    <v-btn
      v-if="v.legname2"
      variant="text"
      color="">
        <span class="text-h5">{{v.legname2}}</span>
        <v-tooltip
          activator="parent"
          location="bottom"
        >
          Leg. Name
        </v-tooltip>
    </v-btn>
    <v-btn
      v-if="v.legnum"
      variant="text"
      color="">
        <span class="text-h5"> {{v.legnum}}</span>
        <v-tooltip
          activator="parent"
          location="bottom"
        >
          Leg. number
        </v-tooltip>
    </v-btn>
    <v-btn
      v-if="v.location"
      @click="overlaylocation = !overlaylocation"
      variant="text"
      color="">
        <span class="text-h5 text-truncate" style="max-width: 400px;">{{ v.location }}</span>
        <v-tooltip
          activator="parent"
          location="bottom"
        >
          Location. Click for more
        </v-tooltip>
    </v-btn>
    <v-overlay
      v-model="overlaylocation"
      class="align-center justify-center"
      scroll-strategy="block"
      max-width="800"
    >
      <card>
        <v-card-title class="bg-white text-h4">Location</v-card-title><v-card-text class="bg-white text-h5">{{ v.location }}</v-card-text> 
      </card>
    </v-overlay>
    <v-btn
                    class="mx-1 mb-1"
                        variant="outlined"
                        color="regular"
                        @click="geoEco = true">
                        <svg-icon type="mdi" :path="mdiArrowExpand"/> Geo-Eco-data
                      </v-btn>
                      </div>
                      <div class="d-sm-flex d-md-none">
                        <v-btn
          class="mx-1 my-1"
                        variant="outlined"
                        color="regular"
                        @click="geoEco = true">
                        <svg-icon type="mdi" :path="mdiArrowExpand"/> Geo-Eco-data
                      </v-btn>
                      </div>                  
  <map-point-widget-ol v-bind="{mode:'view',column:column, mapheight:mapheightpage}" v-model="v.coordinates" class="d-none d-sm-none d-md-flex rounded-0 px-4">
  </map-point-widget-ol>
  <!--mobile-->
  <map-point-widget-ol v-bind="{mode:'view',column:column, mapheight:mapheightpage}" v-model="v.coordinates" class="d-flex d-sm-none d-none d-sm-flex d-md-none">
  </map-point-widget-ol>
  <image-widget v-if="v.specimen_picture" v-bind="{mode:'view',column:meta}" v-model="v.specimen_picture" />


  <v-dialog v-model="geoEco" fullscreen>
            <v-card class="rounded-0">

                    <div class="bg-white">
                      <v-card-title> <point-widget v-bind="{mode:'view',column:column}" v-model="v.coordinates" /> </v-card-title>
                      <v-card-text> <p>{{ v.location }} </p>
                      <p>Leg.: <date-widget v-bind="{mode:'view',column:column}" v-model="v.legdate" /> {{v.legname2}} {{v.legnum}}</p> </v-card-text>
                    </div>
<map-point-widget-ol v-bind="{mode:'view',column:column, mapheight:mapheightfull}" v-model="v.coordinates" >
</map-point-widget-ol>

     <div class="px-2">
              <v-card-actions>
                <v-row justify="space-between" class="text-center">
                  <v-col cols="auto"><v-btn
                    class="my-1"
                    variant="flat" 
                    color="regular" 
                    block @click="geoEco = false"
                  >Close</v-btn></v-col>
                </v-row>
              </v-card-actions>
      </div>
            </v-card>
          </v-dialog>



  <v-expansion-panels class="d-none d-sm-none d-md-flex">
    <v-expansion-panel
      class="px-4 pt-1"
      rounded="0"
    >
    <v-expansion-panel-title 
      @click="getExpansionTitle()"
      color="regularlight"
    >
      {{ expansiontitle }}
    </v-expansion-panel-title>
      <v-expansion-panel-text class="mx-n7">
        <v-sheet class="d-flex flex-wrap">
          <v-sheet
            v-for="col in meta.columns"
            :key="col"
          >
            <v-card
              v-if= "value[col.fieldname] && col.fieldname !='pictures'"
              :title= col.title
              variant= outlined
              class="mx-1 my-1"
            > 
              <v-card-text>
                <base-geo-cell v-bind="{mode:'view', column:col, meta:meta, rowobject:value}" v-model="value[col.fieldname]" /> 
              </v-card-text>
            </v-card>

            <v-card
              v-if= "value[col.fieldname]==undefined"
              :title= col.title
              variant= flat
              color="vs"
            > 
              <v-card-text>
                <p> &nbsp; </p>
              </v-card-text>
            </v-card>
          </v-sheet>
        </v-sheet>
      </v-expansion-panel-text>
    </v-expansion-panel>
  </v-expansion-panels>

  </template>

  <template v-else-if="mode === 'edit'">
      <input class="input" type="date" v-model="v"  @input="handleInput">
  </template>

  <template v-else>
      {{v}}
  </template>
  
</template>

<script>

import ClassifyWidget from '@/components/widgets/ClassifyWidget.vue';
import DetailsWidget from '@/components/widgets/DetailsWidget.vue';
import PointWidget from '@/components/widgets/PointWidget.vue';
import ImageWidget from '@/components/widgets/ImageWidget.vue';
import BaseTablePageTools from '@/components/BaseTablePageTools.vue';
import DateWidget from '@/components/widgets/DateWidget.vue';
//import { LMap, LMarker, LTileLayer, LGeoJson, LControl } from "@vue-leaflet/vue-leaflet";
import MapPointWidgetOl from '@/components/widgets/MapPointWidgetOl.vue';
import BaseGeoCell from '@/components/BaseGeoCell.vue';
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiArrowExpand } from '@mdi/js';

export default {
    name: 'DataMaterialSinglesps',
    props:['mode','meta', 'value'],
    emits: ['update:modelValue'],
    data(){ 
        return {
            v: this.value,
            speciesDetails: false,
            overlaylocation: false,
            metadetails: {},
         mapheightpage: "height: 200px",
         mapheightfull: "height: 50%",
         expansiontitle: "Expand all data",
         geoEco: false,
         mdiArrowExpand:mdiArrowExpand,
        }
    }, 
    
    components: {
      SvgIcon,
DetailsWidget,
PointWidget,
ImageWidget,
BaseTablePageTools,
DateWidget,
MapPointWidgetOl,
BaseGeoCell,
ClassifyWidget,
    },

    mounted(){
      // for (const column of this.meta.columns) {
      //   if(column.fieldname=='species'){
      //   this.metadetails=column;
      //   console.log(column);
      // break;
      //     }
      //   }
    },
    methods:{
      
        handleInput (e) {            
           this.v = e.target.value;            
           this.$emit('update:modelValue', this.v)
        },

        getExpansionTitle() {
          if (this.expansiontitle == "Expand all data") {
            this.expansiontitle = "Hide all data";
          }
          else {
            this.expansiontitle = "Expand all data";
          }
        },

    },




}
</script>